module.exports = __webpack_public_path__ + "static/media/regulamento.c2363e17.pdf";